import { formatFigure } from 'Helpers/formatService';

// A milestone percentage cell: fixed to two decimals, a zero as the dash.
export const fixedPercentFigure = (value) => formatFigure(value, (v, p) => Number(v).toFixed(p), { precision: 2, suffix: '%' });

// A summed percentage cell, shown as the raw sum ("50%", "33.5%"), a zero as the dash.
export const percentFigure = (value) => formatFigure(value, (v) => `${v}`, { precision: 2, suffix: '%' });
